import { Type } from "@angular/core";

export interface StepItem {
    label: string;
    component: Type<any>;
    isCompleted: boolean;
    Type: StepItemType;
}

export enum StepItemType {
    ReferralInfo,
    Defendant,
    Charge,
    Witness,
    Document,
    CoDefendant,
    ReviewSubmit
}

export interface IUploadMugshotModal {
    src: string;
    file: File | null;
    isRemove: boolean;
}